<template>
    <div class="container" style="position: relative; top: 60px; margin-left: 13px;">
        <table class="table table-condensed">
            <thead>
                <tr>
                    <th>Map</th>
                    <th>Host</th>
                    <th>Game Type</th>
                    <th>Winner</th>
                    <th>Score</th>
                    <th>Date</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="game in games" :key="game._id">
                    <td>{{ game.map.name }}</td>
                    <td>{{ game.host }}</td>
                    <td>{{ game.gameType }}</td>
                    <td>{{ game.winner.player }}</td>
                    <td>{{ game.winner.score }}</td>
                    <td>{{ game.createdOn | dateTime }}</td>
                    <td>
                        <router-link :to="`/game/${game._id}`">Game Stats</router-link> | <router-link :to="`/review/${game.map._id}`">Map Details</router-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { api } from '../framework/api';
export default {
    data() {
        return {
            games: []
        }
    },
    async created() {
        let result = await api.get('game');
        this.games = result.data.map(game => {
            game.winner = game.results[0];
            return game;
        });
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Games.vue